// AUTO-GENERATED by scripts/sync-branding.js from ../../../../../app.config.json
// Do not edit manually - it will be overwritten on every build.
// To rebrand this app, edit app.config.json at the repo root instead.
export const branding = {
  "appName": "Canvas",
  "appShortName": "Canvas",
  "appSlug": "canvas",
  "appDescription": "Offline-first field work, anywhere",
  "appTagline": "Built for teams who work where the signal doesn't",
  "baseDomain": "gardenbaysoftware.com",
  "themeColor": "#1976d2"
} as const;
